let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("48pzM")).then(() => parcelRequire('bgdNn'));